function i(t, n) {
  typeof t == "function" ? t(n) : t && (t.current = n);
}
export {
  i as setRef
};
//# sourceMappingURL=misc.js.map
